import type { AssetFileRef } from "../components/upload-assets/types";
import type { BriefMemory } from "../hooks/useBriefMemory";

/**
 * Files in one brief group, deduped by `attachmentId`. Entries missing
 * `attachmentId` or `url` are skipped — `assetFileSchema` rejects them, so the
 * brief should never hold one, and a tile could not render it anyway.
 */
export function collectFiles(group: BriefMemory["assets"]): AssetFileRef[] {
  const seen = new Set<number>();
  const out: AssetFileRef[] = [];

  for (const entry of group?.files ?? []) {
    const file = entry as Record<string, unknown>;

    if (
      typeof file.attachmentId !== "number" ||
      typeof file.url !== "string" ||
      seen.has(file.attachmentId)
    ) {
      continue;
    }
    seen.add(file.attachmentId);

    out.push({
      attachmentId: file.attachmentId,
      mime: typeof file.mime === "string" ? file.mime : null,
      name: typeof file.name === "string" ? file.name : "file",
      size: typeof file.size === "number" ? file.size : null,
      url: file.url,
    });
  }

  return out;
}
